import { useEffect } from "react";
import { useParams } from "react-router-dom";
//import { useDispatch } from "react-redux";
import { useCompteChangeLoginEmailMutation } from "../../../redux/slice/api/FO/compteApi";

//import { resetCompte } from "../../../redux/slice/compte.slice";
import CpntCommunicationBloc from "../components/communication/CpntCommunicationBloc";
//import { toast } from "react-toastify";
import { Type_Return_Message } from "../../../models/interfaces/IReturn_Parent";
//import { ILoginReturn } from "../../../models/interfaces/ILoginReturn";
// import { resetCompte } from "../../../redux/slice/compte.slice";
// import { useDispatch } from "react-redux";
// import { useKeycloak } from "@react-keycloak/web";
import SpinnerEditeurPro from "../components/SpinnerEditeurPro";


export type Param = {
  Code: string;
  NewLogin: string;
};

const PageCompteChangementEmail: React.FC = () => {
  // const dispatch = useDispatch();
  // const {keycloak} = useKeycloak();
  
  const { Code, NewLogin } = useParams<Param>();
    const [
    CompteChangeLoginEmailMutation,
    {
      data,
      isLoading,
      isUninitialized
    },
  ] = useCompteChangeLoginEmailMutation();

  

  useEffect(() => {
    CompteChangeLoginEmailMutation({Code:Code,NewLogin:NewLogin});
    //handleDisconnection();
  }, []);


  // const handleDisconnection = async () => {
  //   if (keycloak.authenticated) {
  //     dispatch(resetCompte());
  //     keycloak.logout();
  //   } 
  // };
  return <>
    {isLoading || isUninitialized || !data ? (
       <SpinnerEditeurPro />
    ) : (
      <CpntCommunicationBloc
        HeaderColorClass={data.Return_IdType_Message === Type_Return_Message.Validation ? "bg-green" : "bg-red"}
        Title={data.Return_IdType_Message === Type_Return_Message.Validation ? "Félicitations !" : "Attention !"}
        DescriptionIconClass={
          data.Return_IdType_Message === Type_Return_Message.Validation
          ? "bi-check-circle-fill fs-1"
          : " bi-x-circle-fill fs-1"
      }
        DescriptionHTML={
          <>
            {data.Return_IdType_Message === Type_Return_Message.Validation && (
              <>Votre email a bien été modifié ! <br /></>
            )}
            {data.Return_IdType_Message === Type_Return_Message.Erreur && (
              <>
                {data?.Return_Message !== "" ? (
                  <>{data?.Return_Message}</>
                ) : (
                  <>Une erreur s&apos;est produite, votre email n&apos;a pas été modifié</>
                )}
              </>
            )}
          </>}
      />)
    }
  </>
};

export default PageCompteChangementEmail;
